




















































import {Component, Mixins} from 'vue-property-decorator'
import {$, MixinUpload, PageCollection, pushByName} from 'simpli-web-sdk'
import {UploadConfig} from '@/config/upload.config'
import {AppConfig} from '@/config/app.config'
import {Getter} from 'vuex-class'
import Responsavel from '@/model/resource/Responsavel'
import {MixinSelect} from '@/components/mixins/MixinSelect'
import {MixinFilter} from '@/components/mixins/MixinFilter'

import ModalSimple from '@/components/modals/ModalSimple.vue'
import SlaFeriado from '@/model/resource/SlaFeriado'

const metaInfo = () => ({
  title: $.t('view.manage.holidayList.title'),
})

@Component({
  metaInfo,
  components: {ModalSimple},
})
export default class ManageHolidayListView extends Mixins(MixinUpload, MixinSelect, MixinFilter) {
  @Getter('auth/responsavel') user!: Responsavel

  readonly UPLOAD_CONFIG = UploadConfig.buildDataPreset(1)

  AppConfig = AppConfig
  pushByName = pushByName

  collection = new PageCollection(SlaFeriado, {}, 10)
  holidayToRemove: SlaFeriado | null = null

  async created() {
    this.collection.endpoint = '/user/sla-feriado'
  }

  async closeDelete() {
    this.holidayToRemove = null
    await this.query()
  }

  async removeHoliday() {
    if (!this.holidayToRemove) {
      return
    }

    await this.holidayToRemove.removeSlaFeriado(this.holidayToRemove.idSlaFeriadoPk)
    await this.collection.search()
    this.holidayToRemove = null
  }
}
